import React from "react";
import moment from "moment";
import withStyles from "@material-ui/styles/withStyles";
import { Field } from "react-final-form";
import MetaError from "../MetaError";
import { styles } from "./_base.styles";
import { DateInput } from "../../inputs";

function DateField({ classes, className, id, label, disabled, required, placeholder, minDate, maxDate, onChange }) {
  const onChangeHandler = (v, input) => {
    let nValue = (moment.isMoment(v) && v.isValid()) ? v.format("YYYY-MM-DDT00:00:00") : undefined;
    input.onChange && input.onChange(nValue);
    onChange && onChange(nValue)
  };

  return (
    <div className={classes.root}>
      <Field name={id}>
        {({ input, meta }) => (
          <>
            <DateInput
              className={classes.input + (className ? " " + className : "")}
              id={id}
              label={label}
              value={input.value}
              onChange={(value) => onChangeHandler(value, input)}
              disabled={disabled}
              required={required}
              error={Boolean(meta.error && meta.touched)}
              placeholder={placeholder}
              minDate={minDate}
              maxDate={maxDate}
            />
            <div className={"FormFieldError " + classes.error}>
              <MetaError meta={meta} />
            </div>
          </>
        )}
      </Field>
    </div>
  );
}

export default withStyles(styles)(DateField);
